import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import AccessoryPageComponent from './AccessoryPageComponent';

import coreActions from '../../core/actions';
import accessoriesActions from '../actions/AccessoriesActions';

const allActions = { ...accessoriesActions, ...coreActions };

const mapStateToProps = ({ config, accessories }) => ({
  config,
  accessories,
});

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators(allActions, dispatch),
});

export default connect(mapStateToProps, mapDispatchToProps)(AccessoryPageComponent);
